// extracted by mini-css-extract-plugin
export var container = "_dt-0";
export var containerTopRight = "_dt-1";